(function () {
    "use strict";

    angular.module("app").factory("errorHandler", ErrorHandlerFactory);

    ErrorHandlerFactory.$inject = ["notificationService"];
    function ErrorHandlerFactory(notificationService) {

        return {
            ShowError: (error) => DoShowError(notificationService, error),
        };
    }
})();